import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useToken from 'hooks/useToken';

import { Col, Row } from 'react-bootstrap';

import Saludo from './saludo';
import ListaPagosRecibidos from './listaPagosRecibidos';

const pagosrecibidos = () => {

    const navigate = useNavigate();
    const { token, idCatTipoUsuario } = useToken();


    /**
 * Verifica los permisos
 */
    const checkPermisos = async () => {

        const response = await fetch("/api/Administradores/checkPermisos",
            {
                method: 'POST',
                headers:
                {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            }).catch((error) => {
                console.log('Hubo un problema con la peticion Fetch:' + error);
            });

        if (response.ok) {
            const responseType = await response.json();
            console.log(responseType);

            if (responseType.iResponseType == 1) {
                //
            } else {
                navigate("/");
            }

        }
        else {
            navigate("/");
        }
    }

    /**
    * Se ejecuta la primera vez
    */
    useEffect(() => {
        if (idCatTipoUsuario != 1) {
            navigate("/");
        }

        checkPermisos();

    }, []);

    return (
        <>
            <Row>
                <Col className="col-12">
                   <Saludo/>
                </Col>
                <Col className="col-12">
                    <ListaPagosRecibidos />
                </Col>
            </Row>
        </>
    );
};

export default pagosrecibidos;